<div class="container mx-auto px-4 py-6">
  <div class="mx-auto max-w-7xl"> 
    <div class="bg-white rounded-lg shadow border border-gray-200">
      <!-- Tabs Navigation -->
      <div class="border-b border-gray-200">
        <nav class="flex -mb-px">
          <button 
          *ngIf="isGM || isDeveloper"
            (click)="activeTab = 'active'"
            [class]="activeTab === 'active' 
              ? 'border-blue-500 text-blue-600 whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm'"
          >
            Active Questions
            <span class="ml-2 bg-blue-100 text-blue-600 py-0.5 px-2.5 rounded-full text-xs">
              {{activeQuestions.length}}
            </span>
          </button>
          <button 
          *ngIf="isTech"
          (click)="activeTab = 'myQuestions'"
          [class]="activeTab === 'myQuestions' 
            ? 'border-blue-500 text-blue-600 whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm'"
        >
          My Questions
          <span class="ml-2 bg-blue-100 text-blue-600 py-0.5 px-2.5 rounded-full text-xs">
            {{myQuestions.length}}
          </span>
        </button>
          <button 
            *ngIf="isGM || isDeveloper"
            (click)="activeTab = 'add'"
            [class]="activeTab === 'add' 
              ? 'border-blue-500 text-blue-600 whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm'"
          >
            Add Questions
          </button>
        </nav>
      </div>
      <!-- Active Questions Tab -->
      <div *ngIf="activeTab === 'active'" class="p-4">
        <div *ngFor="let techGroup of groupedQuestions | keyvalue" class="mb-8">
          <!-- Tech Header (Clickable) -->
          <div (click)="toggleTechGroup(techGroup.key)"
              class="flex items-center mb-4 cursor-pointer hover:bg-gray-50 p-2 rounded-lg">
            <div class="flex items-center">
              <svg [class]="expandedTechGroups[techGroup.key] ? 'transform rotate-90' : ''"
                  class="h-5 w-5 text-gray-500 transition-transform duration-200 mr-2"
                  fill="none" 
                  viewBox="0 0 24 24" 
                  stroke="currentColor">
                <path stroke-linecap="round" 
                      stroke-linejoin="round" 
                      stroke-width="2" 
                      d="M9 5l7 7-7 7" />
              </svg>
              <h3 class="text-lg font-medium text-gray-900">{{techGroup.key}}</h3>
              <span class="ml-2 bg-blue-100 text-blue-600 py-0.5 px-2.5 rounded-full text-xs">
                {{techGroup.value.length}} questions
              </span>
            </div>
          </div>

          <!-- Questions for this Tech (Collapsible) -->
          <div *ngIf="expandedTechGroups[techGroup.key]"
              class="space-y-6"
              [@expandCollapse]>
            <div *ngFor="let question of techGroup.value" 
                class="bg-white rounded-lg border border-gray-200 overflow-hidden">
              <!-- Question Header -->
              <div (click)="toggleQuestion(question)"
                  class="p-4 bg-gray-50 border-b border-gray-200 cursor-pointer hover:bg-gray-100 transition-colors">
                <div class="flex flex-col space-y-2">
                  <div class="flex justify-between items-start">
                    <div class="flex items-center space-x-2">
                      <svg [class]="question.isExpanded ? 'transform rotate-90' : ''"
                          class="h-5 w-5 text-gray-500 transition-transform duration-200"
                          fill="none" 
                          viewBox="0 0 24 24" 
                          stroke="currentColor">
                        <path stroke-linecap="round" 
                              stroke-linejoin="round" 
                              stroke-width="2" 
                              d="M9 5l7 7-7 7" />
                      </svg>
                      <span class="text-sm font-medium text-gray-600">
                        Question {{activeQuestions.indexOf(question) + 1}}
                      </span>
                    </div>
                    <span class="text-sm text-gray-500">{{question.createdAt | date:'MMM d, y'}}</span>
                    <button (click)="$event.stopPropagation(); confirmDelete(question)"
                            class="p-1.5 text-gray-500 hover:text-red-600 rounded-full hover:bg-red-50 
                                  transition-colors duration-200 focus:outline-none focus:ring-2 
                                  focus:ring-red-500 focus:ring-offset-2">
                      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" 
                              stroke-linejoin="round" 
                              stroke-width="2" 
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                  <p class="text-gray-900 font-medium">{{question.question}}</p>
                  <!-- Reply Count Badge -->
                  <div class="flex items-center mt-2">
                    <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                      {{question.answers.length}} replies
                    </span>
                  </div>
                </div>
              </div>

              <!-- Rest of your existing question content -->
              <div *ngIf="question.isExpanded"
                  class="transition-all duration-200 ease-in-out"
                  [@expandCollapse]>
                <!-- Replies Thread -->
                <div class="divide-y divide-gray-200">
                  <!-- Individual Replies -->
                  <div *ngFor="let reply of question.answers" 
                      class="p-4 pl-8 bg-white">
                    <div class="flex flex-col space-y-2">
                      <div class="flex justify-between items-start">
                        <div class="flex items-center space-x-2">
                          <span class="text-sm font-medium text-gray-900">From: {{reply.user?.name || 'Unknown User'}}</span>
                          <!-- <span class="text-xs text-gray-500">({{reply.}})</span> -->
                        </div>
                        <!-- <span class="text-sm text-gray-500">{{question.createdAt | date:'MMM d, y h:mm a'}}</span> -->
                      </div>
                      <p class="text-gray-600">{{reply.text}}</p>
                    </div>
                  </div>
        
                  <!-- Reply Input Section -->
                  <div class="p-4 pl-8 bg-white">
                    <div *ngIf="!question.isReplying">
                      <button 
                        (click)="question.isReplying = true"
                        class="inline-flex items-center text-sm text-blue-600 hover:text-blue-800 font-medium">
                        <svg class="h-4 w-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd" d="M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                        </svg>
                        Reply
                      </button>
                    </div>
                    
                    <div *ngIf="question.isReplying" class="space-y-3">
                      <textarea 
                        [(ngModel)]="question.replyText"
                        rows="2"
                        class="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white text-sm"
                        placeholder="Type your reply..."></textarea>
                      <div class="flex space-x-3">
                        <!-- <button 
                          (click)="submitReply(question)"
                          class="inline-flex items-center px-3 py-1.5 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                          Submit Reply
                        </button> -->
                        <button 
                          (click)="question.isReplying = false"
                          class="inline-flex items-center px-3 py-1.5 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- My Questions Tab -->
      <div *ngIf="activeTab === 'myQuestions'" class="p-4">
        <div class="space-y-6">
          <div *ngFor="let question of myQuestions" 
              class="bg-white rounded-lg border border-gray-200 overflow-hidden">
            <!-- Question Header -->
            <div (click)="toggleQuestion(question)"
                class="p-4 bg-gray-50 border-b border-gray-200 cursor-pointer hover:bg-gray-100">
              <div class="flex flex-col space-y-2">
                <div class="flex justify-between items-start">
                  <div class="flex items-center space-x-2">
                    <svg [class]="question.isExpanded ? 'transform rotate-90' : ''"
                        class="h-5 w-5 text-gray-500 transition-transform duration-200"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                    </svg>
                    <span class="text-sm font-medium text-gray-600">From: {{question.createdBy.name}}</span>
                  </div>
                  <span class="text-sm text-gray-500">{{question.createdAt | date:'MMM d, y'}}</span>
                </div>
                <p class="text-gray-900 font-medium">{{question.question}}</p>
                <!-- Reply Count --> 
                <span [class]="question.answers.length === 0 
                ? 'text-sm font-bold text-red-600' 
                : 'text-sm text-gray-500'">
                <ng-container *ngIf="question.answers.length === 0">
                  You have not replied
                </ng-container>
                <ng-container *ngIf="question.answers.length > 0">
                  You provided {{question.answers.length}} {{question.answers.length === 1 ? 'reply' : 'replies'}}
                </ng-container>
              </span>
              </div>
            </div>

            <!-- Expanded Content -->
            <div *ngIf="question.isExpanded" class="p-4" [@expandCollapse]>
              <!-- Existing Answers -->
              <div *ngFor="let answer of question.answers" 
                  class="mb-4 pl-4 border-l-2 border-gray-200">
                <div class="flex justify-between items-start">
                  <span class="text-sm font-medium">{{answer.user?.name || 'Unknown User'}}</span>
                  <span class="text-sm text-gray-500">{{answer.createdAt | date:'short'}}</span>
                </div>
                <p class="text-gray-600 mt-1">{{answer.text}}</p>
              </div>

              <!-- Answer Input -->
              <div class="mt-4">
                <textarea 
                  [(ngModel)]="question.replyText"
                  rows="3"
                  class="w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Type your answer..."></textarea>
                <div class="mt-2 flex justify-end space-x-2">
                  <button 
                    (click)="submitAnswer(question)"
                    class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
                    Submit Answer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
          
      <!-- Add Questions Tab -->
      <div *ngIf="activeTab === 'add'" class="p-4">
        <div class="flex flex-col md:flex-row gap-6">
          <!-- Tech Selection Section - Left Side -->
          <div class="md:w-1/3">
            <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
              <h2 class="text-xl font-semibold mb-4 text-gray-800">Select Technicians</h2>
              <div class="space-y-2 max-h-[600px] overflow-y-auto">
                <div *ngFor="let tech of techUsers" 
                    class="flex items-center p-2 hover:bg-white rounded-md">
                  <input 
                    type="checkbox"
                    [id]="'tech-' + tech._id"
                    [value]="tech._id"
                    (change)="toggleTechSelection(tech)"
                    [checked]="tech._id ? isSelected(tech._id) : false"
                    class="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500">
                  <label [for]="'tech-' + tech._id" 
                        class="ml-3 block text-sm font-medium text-gray-700 cursor-pointer">
                    {{ tech.name }}
                  </label>
                </div>
              </div>
              <!-- Selected Count -->
              <div class="mt-4 text-sm text-gray-600">
                Selected: {{selectedTechs.length}} technician(s)
              </div>
            </div>
          </div>

          <!-- Questions Section - Right Side -->
          <div class="md:w-2/3">
            <!-- Existing Questions List -->
            <div class="space-y-4">
              <div *ngFor="let question of questions; let i = index" 
                    class="p-4 bg-gray-50 rounded-lg border border-gray-200">
                <div class="flex justify-between items-start">
                  <div class="flex-grow">
                    <textarea 
                      [(ngModel)]="question.text"
                      rows="3"
                      class="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                      placeholder="Enter your question here..."></textarea>
                  </div>
                  <button 
                    (click)="removeQuestion(i)"
                    class="ml-2 p-2 text-red-600 hover:text-red-800">
                    <span class="sr-only">Remove question</span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <!-- Button Group -->
            <div class="space-y-4 mt-4">
              <!-- Add Question Button -->
              <button 
                *ngIf="questions.length > 0"
                (click)="addQuestion()"
                class="flex items-center justify-center w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
                </svg>
                Add Another Question
              </button>

              <!-- Initial Add Question Button -->
              <button 
                *ngIf="questions.length === 0"
                (click)="addQuestion()"
                class="flex items-center justify-center w-full px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
                </svg>
                Add Question
              </button>

              <!-- Submit Button --> 
              <button  
                *ngIf="questions.length > 0 && selectedTechs.length > 0"
                (click)="submitQuestions()"
                class="w-full px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors">
                Submit Questions for {{selectedTechs.length}} Technician(s)
              </button>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
</div>